module.exports = __webpack_public_path__ + "img/icon_3_27.c0f6011d.png";